<template>
    <div class="contractList">
        <div class="titleBox">
            <div class="title">
                {{data.title}}
            </div>
            <div class="details">
                {{data.details}}
            </div>
        </div>
        <el-image lazy v-for="(item,i) in data.images" :key="i" :src="item"/>
    </div>
</template>
<script>
    import { 
        goodsInfo,
    } from "@/api/api.js";
    
    export default {
        name: "goodsInfo",
        data(){
            return {
                id:0,
                data:[]
            }
        },
        created(){
    
            if(this.$route.query.id == undefined || this.$route.query.id == ''){
              this.$message.error('商品不存在');
              this.$router.push({ name: 'homeInfo'})
            }
            this.id = this.$route.query.id
            this.info()
        },
        methods:{
            info(){
                let data = {
                    id:this.id
                }
                goodsInfo(data).then(res=>{
                    this.data = res.data
                })
            },
        }
    }
    </script>
<style lang="scss" scoped>
    .contractList{
        text-align: left;
        background-color: #f3f3f3;
        width: 800px;
        margin: 0 auto;
        .titleBox{
            
            background-color: #fff;
            padding: 1.5rem;
            margin-bottom: 1rem;
            .title{
                font-size: 1.2rem;
            }
            .details{
                font-size: 0.8rem;
                line-height: 1.5rem;
                margin-top: .3rem;
                color: #a8a8a8;
            }
        }
    }
</style>